<template>
    <div class="container">
        <h1>Katameya Clinic Hospital</h1>
            <div class="row">
                <div class="col-lg-6 col-md-6 cont1">
                    <h4>Location: <span>New Cairo</span></h4>
                    <h4>Scope of work: <span>Problem analysis, Testing and balancing</span></h4>
                    <h4>Project size: <span>4 AHU-2 CHWP-200 AIR TERMINALS -100 B.V</span></h4>
                    <h4>Consultant: <span>MED</span></h4>
                    <h4>Contractor: <span>united group for electromechanical works</span></h4>
                </div>
                <div class="col-lg-5 col-md-5 cont2">
                    <img src="@/images/clients/kattamya.jpg" alt="">
                </div>
            </div>
            
    </div>
</template>
<style lang="scss" scoped>
.container{
    margin:40px 20;
    padding: 30px 15px;
}
h1{
    text-transform: uppercase;
    color:#075daa;
    margin-bottom: 15px;
}
h4{
    color: red;
}
span{
    color: black;
}
@media (max-width: 767px) {
 .cont1:nth-of-type(1) {
    order: 2;
  }
  .cont2:nth-of-type(2) {
    order: 1;
  }
}

.cont2 img {
    width:100%;
    height: 100%;
}
h1{
    color:#075daa;
}

</style>